export default "__VITE_ASSET__CMyLwjfL__"